module.exports = __webpack_public_path__ + "img/siriusLogo.252ffd35.png";